import React from 'react';

import { Modal, ModelHeader, ModalBody, ModalFooter } from '../../../common/input/modal/Modal';
import logoimg from '../../../assets/images/logo.png';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';


const CommonTableModalView = (props) => {
    const contract_type_arr = {1:'Emergency',2:'Temporary',3:'Permanent'};
    const carer_type_arr = {1:'Nurses',2:'Carers'};
    
    console.log(props);
    console.log("THESE ARE THE PROPS");
    function days_between(date1) {
        const date2 = new Date();
        date1 = new Date(date1);
        // The number of milliseconds in one day
        const ONE_DAY = 1000 * 60 * 60 * 24;

        // Calculate the difference in milliseconds
        const differenceMs = date1 - date2;
        if (differenceMs <= 0) {
            return "Stating Job has expired";
        }
        // Convert back to days and return
        return "Start Date: " + Math.round(differenceMs / ONE_DAY) + " Days";

    }
    var check = props.application_detail.shifts != [] ? true : false;
    check = props.application_detail.shifts != undefined ? true : false;
    if (check) {
        check = props.application_detail.shifts.length != 0 ? true : false;

    }
    return (
        <>
            <Modal className="price-calculator-popup" show={props.modal_table_show} onHide={props.hideTableModal}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="price-calculator-pop-cont-wrap">
                                <ModelHeader>
                                    <div className="price-calculator-pop-header p-3" >
                                        <div className="d-flex justify-content-between " style={{ fontSize: '18px' }}>
                                            <div className="d-flex flex-column align-items-start p-2" >
                                                <h4>Applicant's List</h4>
                                                <div> {check ? days_between(props.application_detail.shifts[0].start_date) : "--"} </div>
                                            </div>


                                            <div className="p-2 border" style={{ width: '500px' }}>
                                                {/* <div className="d-flex flex-column align-items-start p-2">
                                             <div>Client Name:{props.application_detail.customer}</div>
                                             <div>JOb Number:{props.application_detail.job_number}</div>
                                             <div>Job Type:{props.application_detail.job_type} </div>
                                             </div>
                                             
                                             <div className="d-flex flex-column align-items-start p-2">
                                             <div>Location:  {props.application_detail.city}</div>
                                             <div>Grade: G3</div>
                                             <div>Type: Carer</div>
                                             </div> */}

                                                <Row>
                                                    {console.log(props.application_detail)}
                                                    <Col className='col' style={{ fontSize: '13px', textAlign: 'left' }}><span style={{ display: 'inline-block' }}><strong>Job Title:</strong></span> {props.application_detail.title}</Col>
                                                    <Col className='col' style={{ fontSize: '13px', textAlign: 'left' }}><strong>Care Type:</strong> {carer_type_arr[props.application_detail.carertype]}</Col>
                                                </Row>
                                                <Row>
                                                    <Col className='col' style={{ fontSize: '13px', textAlign: 'left' }}><span style={{ display: 'inline-block' }}><strong>Job Number:</strong></span> {props.application_detail.job_number}</Col>
                                                    <Col className='col' style={{ fontSize: '13px', textAlign: 'left' }}><strong>Contract Type:</strong> {contract_type_arr[props.application_detail.contract_type]}</Col>
                                                </Row>
                                                <Row>
                                                    <Col className='col' style={{ fontSize: '13px', textAlign: 'left' }}><span style={{ display: 'inline-block' }}><strong>Job Type:</strong></span> {props.application_detail.job_type}</Col>
                                                </Row>


                                            </div>


                                        </div>
                                    </div>
                                </ModelHeader>
                                <ModalBody>
                                    <div className="table-area applied-job-table p-2">
                                        <h4>Candidate Details</h4>
                                        <Table responsive>
                                            {/* <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Type</th>
                                            <th>Gap</th>
                                             <th>Scale</th>
                                             <th>Distance</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {props.application_detail.eligible_candaidates != undefined ? props.application_detail.eligible_candaidates.map((cand) => (
                                    	<tr>
                                    		<td>{cand.id}</td>
                                            <td>{cand.first_name} {cand.last_name}</td>
                                            <td>{cand.type}</td>
                                            <td>{cand.Gap}</td>
                                            <td>{cand.scale}</td>
                                            <td>{cand.distance}</td>
                                            <td>{cand.applicant_status}</td>
                           
                                            <td>
                                            <Link><i style={{marginRight: '15px',color: 'black'}} class="fa fa-plus " aria-hidden="true"></i></Link> 
                                            <Link><i style={{marginRight: '10px',color: 'black'}} class="fa fa-minus " aria-hidden="true"></i></Link>
                                            </td>
                                            
                                        </tr>
                                    	)) :""}
                                  
                                       
                                    </tbody> */}

                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Name</th>
                                                    <th>email</th>
                                                    <th>City</th>
                                                    <th>Postal Code</th>
                                                    <th>Status</th>
                                                    <th>Action</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props.application_detail.eligible_candidates != undefined ? props.application_detail.eligible_candidates.map((cand) => (
                                                    <tr>
                                                        <td>{cand.id}</td>
                                                        <td>{cand.first_name} {cand.last_name}</td>
                                                        <td>{cand.email}</td>
                                                        <td>{cand.city}</td>
                                                        <td>{cand.zipcode}</td>
                                                        {console.log(cand.applicant_status)}
                                                        <td>{cand.applicant_status && cand.applicant_status.applicant_real_status}</td>

                                                        <td>
                                                            <Link href=""><i style={{ marginRight: '15px', color: 'black' }} class="fa fa-plus " aria-hidden="true"></i></Link>
                                                            <Link href=""><i style={{ marginRight: '15px', color: 'black' }} class="fa fa-minus " aria-hidden="true"></i></Link>
                                                        </td>

                                                    </tr>
                                                )) : ""}


                                            </tbody>
                                        </Table>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <div className="wage-pop-footer">
                                        <div className="logo"><img src={logoimg} alt="" /></div>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default CommonTableModalView;
